import React from 'react';
import { styled } from 'baseui';
import { Button, KIND as BUTTON_KIND } from 'baseui/button';
const ButtonsContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  gap: $theme.sizing.scale300,
  padding: `${$theme.sizing.scale300} 0`
}));
const buttonOverrides = {
  BaseButton: {
    style: {
      flex: 1
    }
  }
};
type PropsT = {
  checkedAnnotationIds: string[];
  onSelectAll: () => void;
  onImport: () => void;
};
export function ActionButtons({
  checkedAnnotationIds,
  onSelectAll,
  onImport
}: PropsT) {
  const isImportEnabled = checkedAnnotationIds.length > 0;
  return <ButtonsContainer>
      <Button overrides={buttonOverrides} kind={BUTTON_KIND.secondary} onClick={onSelectAll}>
        Select All
      </Button>
      <Button overrides={buttonOverrides} onClick={onImport} disabled={!isImportEnabled}>
        Import
      </Button>
    </ButtonsContainer>;
}